import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import en from "./locales/en.json";
import ar from "./locales/ph.json";

i18n.use(initReactI18next).init({
  resources: {
    en: { translation: en },
    ar: { translation: ar },
  },
  lng: "z",
  fallbackLng: "en",
  interpolation: {
    escapeValue: false,
  },
});

i18n.dir = () => "ltr";

export default i18n;